
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 117 42"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFFFFE","fill-rule":"evenodd","d":"M0 41.513c0-7.882 6.39-14.271 14.272-14.271 3.38 0 6.485 1.178 8.93 3.143 3.232-6.506 9.94-10.98 17.698-10.98.782 0 1.551.051 2.309.14 2.19-4.756 6.993-8.058 12.572-8.058 2.013 0 3.923.433 5.649 1.206C65.203 5.17 72.983 0 81.974 0c12.688 0 22.974 10.286 22.974 22.974 0 1.485-.147 2.935-.416 4.342 6.775 1.274 11.902 7.218 11.902 14.363H.004c0-.055-.004-.11-.004-.166z"}})])
          )
        }
      }
    